import { useLocation } from "react-router-dom";
import Button from "../components/common/Button";
import SearchInput from "../components/common/SearchInput";
import ProfileDropdown from "./ProfileDropdown";

function MenuIcon() {
  return (
    <svg viewBox="0 0 24 24">
      <path d="M4 7h16M4 12h16M4 17h16" />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.33 1.77.62 2.61a2 2 0 0 1-.45 2.11L8 9.72a16 16 0 0 0 6.28 6.28l1.28-1.28a2 2 0 0 1 2.11-.45c.84.29 1.71.5 2.61.62A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}

function BellIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  );
}

const pageTitles = {
  "/dashboard": "Performance Overview",
  "/calls": "Calls",
  "/analytics": "Analytics",
  "/lead-management": "Contacts / Leads",
  "/appointments": "Appointments",
  "/campaigns": "Campaigns",
  "/team-management": "Team Management",
  "/settings": "Settings",
};

export default function Header({
  onToggleSidebar,
  onOpenOutboundModal,
}) {
  const { pathname } = useLocation();
  const pageTitle = pageTitles[pathname] || "Nexora Calling";

  return (
    <header className="header">
      <div className="header-brand">
        <button
          type="button"
          className="menu-toggle-btn"
          onClick={onToggleSidebar}
          aria-label="Toggle navigation"
        >
          <MenuIcon />
        </button>
        <div className="header-title">{pageTitle}</div>
      </div>
      <div className="header-center">
        {/* TODO(ui): global search action is blocked by missing command/search logic. */}
        <SearchInput
          className="header-search"
          value=""
          onChange={() => undefined}
          placeholder="Search workspace"
          aria-label="Search workspace"
          readOnly
        />
      </div>
      <div className="header-right">
        <Button
          variant="primary"
          size="sm"
          className="header-call-btn"
          leftIcon={<PhoneIcon />}
          onClick={onOpenOutboundModal}
        >
          Outbound Call
        </Button>
        <div className="live-badge" aria-label="Live system status">
          <span className="live-dot" />
          <span>Live</span>
        </div>
        <button
          type="button"
          className="header-icon-btn"
          aria-label="Open notifications"
        >
          <BellIcon />
        </button>
        <ProfileDropdown />
      </div>
    </header>
  );
}
